// Builds a spec-compliant otpauth:// URI for TOTP enrollment.
// Used to render the MFA setup QR code and (later) an "open in authenticator"
// affordance. Kept dependency-free so it can be unit-tested in isolation.
//
// Reference: https://github.com/google/google-authenticator/wiki/Key-Uri-Format
export function buildOtpauthUri({ secret, email, issuer }) {
  const label = `${encodeURIComponent(issuer)}:${encodeURIComponent(email)}`;
  const params = `secret=${secret}&issuer=${encodeURIComponent(issuer)}`;
  return `otpauth://totp/${label}?${params}`;
}
